import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import axios from 'axios';
import Api from '../utils/api';
import { STORAGE } from '../constants';

var FreePdf = /*#__PURE__*/function (_Api) {
  _inheritsLoose(FreePdf, _Api);

  function FreePdf() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Api.call.apply(_Api, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "startSession", function (intercomId) {
      return _this.post('/start', {
        data: {
          intercomId: intercomId
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "uploadToS3", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var signedUrl, file, options;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                signedUrl = _ref.signedUrl, file = _ref.file;
                options = {
                  headers: {
                    'Content-Type': file.type
                  }
                };
                return _context.abrupt("return", axios.put(signedUrl, file, options));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "redactPDF", function (payload) {
      return _this.post('/redact', {
        data: payload
      });
    });

    _defineProperty(_assertThisInitialized(_this), "reviewPDF", function (payload) {
      return _this.post('/review', {
        data: payload
      });
    });

    _defineProperty(_assertThisInitialized(_this), "cancel", function () {
      return _this.post('/cancel');
    });

    _defineProperty(_assertThisInitialized(_this), "feedback", function (data) {
      return _this.post('/feedback', {
        data: data
      });
    });

    return _this;
  }

  return FreePdf;
}(Api);

var freePdf = new FreePdf({
  baseURL: process.env.REACT_APP_API,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});
freePdf.setAuthToken(localStorage.getItem(STORAGE.authToken));
export default freePdf;